import { useState, useEffect } from 'react'
import React from 'react';
import { useParams } from 'react-router-dom';
import '../styles/App.css';
import GuessSword from './GuessSword.js';
import InputSword from './InputSword.js';
import GrilleSword from './GrilleSword.js';
import Countdown from './Countdown.js';
import Prev from './Prev.js';
import Rules from './Rules.js';
import Nav from './Nav.js';
const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;


function ModeSword() {

  const gameMode = 'sword'
  const { id } = useParams();
  const isArchive = !!id;

  // Crée un nouvel objet Date avec la date et l'heure actuelles
  var dateDuJour = new Date();
  // Récupère les composantes de la date
  var annee = dateDuJour.getFullYear();
  var mois = (dateDuJour.getMonth() + 1).toString().padStart(2, '0'); // Les mois commencent à 0 en JS, donc on ajoute 1
  var jour = dateDuJour.getDate().toString().padStart(2, '0');
  // Formate la date en "yyyy-mm-dd"
  var dateFormatee = `${annee}-${mois}-${jour}`;


  const [swordFind, setswordFind] = useState(0);

  // Clé localStorage distincte pour le mode archive (par id), pour ne pas
  // écraser la progression du puzzle du jour
  const storageKey = isArchive ? `rows-sword-archive-${id}` : 'rows-swords';

  const savedrowsLocal = localStorage.getItem(storageKey)
  let savedrows = null;
  if (savedrowsLocal ) {  
    savedrows = isArchive
      ? JSON.parse(savedrowsLocal) // en archive, pas de filtre par date : toute la partie appartient à ce puzzle
      : JSON.parse(savedrowsLocal).filter(row => row.dateFormatee === dateFormatee && row.gameMode === gameMode); 
    }
  // const savednbTestMax = localStorage.getItem('nbTestMax')
  const [swordNow, setSwordNow] = useState([]);
  const [nbTest, nbTestUpdate] = useState(savedrows ? savedrows.length : 0)
  const [nbTestMax, nbTestMaxUpdate] = useState(nbTest === 10 ? 1 : 0)

  
  // Initialiser swordNow avec l'épée du jour OU l'épée archivée
  useEffect(() => {
    const fetchswordNow = async () => {
      try {
        const url = isArchive
          ? `${URL_BACKEND}/api/history/sword/${id}`
          : `${URL_BACKEND}/api/swords-now`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const swordNow = await response.json();
        console.log('Data swordNow fetched successfully:', swordNow);
        setSwordNow(swordNow);
        console.log('swordNow', swordNow);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchswordNow();
  }, [id, isArchive]);

  
	const [rows, rowsUpdate] = useState(savedrows ? savedrows : [])
  // Stockage des inputs dans le localstorage + mise à jour
	useEffect(( ) => {
    if (swordNow.length === 0) {
      // Wait until swordNow is fetched
      return;
    }
		localStorage.setItem(storageKey, JSON.stringify(rows))

    // Mise à jour du nombre de coup
    nbTestUpdate(rows.length)
    console.log('lenght', rows.length)
    // Mise à jour si le nombre de coup est de 10
    rows.length === 10 ? nbTestMaxUpdate(1) : nbTestMaxUpdate(0)
    
    // Mise à jour si le nombre de coup est de 10
    if (rows.length > 0 && rows[0].id_epee === swordNow.id_epee) { setswordFind(1) } else  { setswordFind(0) }

    // On met à jour localStorage pour mettre la valeur solved à 1 si l'épée a été trouvée
    if (rows.length > 0 && (rows[0].id_epee === swordNow.id_epee || rows.length === 10)) {
      const solvedKey = isArchive ? 'solved-archive' : 'solved-today';
      const mode = 'sword';
      const swordId = isArchive ? Number(id) : 'today';
      const solvedValue = rows.length === 10 ? 0 : 1;

      // on relit tout l'objet racine (tous les modes), pas juste 'sword'
      const root = JSON.parse(localStorage.getItem(solvedKey) || '{}');

      // on récupère le sous-objet du mode courant, sécurisé si absent/corrompu
      const modeData =
        root[mode] && typeof root[mode] === 'object' ? root[mode] : {};

      // on fusionne : on garde les autres ids, on met à jour/ajoute swordId
      root[mode] = {
        ...modeData,
        [swordId]: { state: 1, solved: solvedValue },
      };

      localStorage.setItem(solvedKey, JSON.stringify(root));

      console.log(`localStorage['${solvedKey}'] after update:`, root);
    }


	}, [rows, swordNow])

    return (
      <div >
        <Nav />
        
        <InputSword       
            gameMode={gameMode} 
            rows={rows}
            rowsUpdate={rowsUpdate}
            swordNow={swordNow}
            setSwordNow={setSwordNow}
            swordFind={swordFind}
            nbTestMax={nbTestMax}
            nbTest={nbTest}
            dateFormatee={isArchive ? swordNow.date_historique : dateFormatee}
        />
        {nbTestMax === 1 || swordFind === 1 ?
          (!isArchive && <Countdown />)
          : <GuessSword       
              gameMode={gameMode} 
              swordNow={swordNow}
              nbTest={nbTest}
          />
        }
        
        <GrilleSword
            gameMode={gameMode} 
            rows={rows}
            rowsUpdate={rowsUpdate}
            swordNow={swordNow}
        />
        
        <Prev 
          gameMode={gameMode} 
          isArchive={isArchive}
          currentId={id}
        />
        <Rules 
          gameMode={gameMode} 
        />   
    </div>
	)
}

export default ModeSword
